import actionTypes from "../common/actionTypes";
// constants
import { DATABASE_STATUTES } from "../common/constants";

const bisNotificationsReducer = (state, action) => {
  switch (action.type) {
    // fetch bis notifications
    case actionTypes.FETCH_BIS_NOTIFICATIONS:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.FETCH_BIS_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.FETCH_BIS_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.EXPORT_BIS_CSV:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default bisNotificationsReducer;
